import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-limit-warning-toast',
  templateUrl: './limit-warning-toast.component.html',
  styleUrl: './limit-warning-toast.component.scss'
})
export class LimitWarningToastComponent {
  @Input() remaining: number = 0
  @Output() upgrade = new EventEmitter<void>()
  @Output() closed = new EventEmitter<void>()

  ngOnInit() {
    setTimeout(() => {
      this.closed.emit()
    }, 4000) // auto hide after 4 seconds
  }
}
